import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArchiveIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 14",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0.666748 2.33301C0.666748 1.22844 1.56218 0.333008 2.66675 0.333008H13.3334C14.438 0.333008 15.3334 1.22844 15.3334 2.33301C15.3334 3.43758 14.438 4.33301 13.3334 4.33301H2.66675C1.56218 4.33301 0.666748 3.43758 0.666748 2.33301Z"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.66675 5.66634C2.29856 5.66634 2.00008 5.96482 2.00008 6.33301V9.82721C2.00007 10.3638 2.00007 10.8068 2.02954 11.1676C2.06016 11.5423 2.12587 11.8868 2.29073 12.2103C2.54639 12.7121 2.95434 13.12 3.45611 13.3757C3.77966 13.5406 4.12413 13.6063 4.49886 13.6369C4.85966 13.6664 5.30256 13.6664 5.8392 13.6663H10.161C10.6976 13.6664 11.1405 13.6664 11.5013 13.6369C11.876 13.6063 12.2205 13.5406 12.5441 13.3757C13.0458 13.12 13.4538 12.7121 13.7094 12.2103C13.8743 11.8868 13.94 11.5423 13.9706 11.1676C14.0001 10.8068 14.0001 10.3639 14.0001 9.82722V6.33301C14.0001 5.96482 13.7016 5.66634 13.3334 5.66634H2.66675ZM6.66675 7.66634C6.29856 7.66634 6.00008 7.96482 6.00008 8.33301C6.00008 8.7012 6.29856 8.99967 6.66675 8.99967H9.33341C9.7016 8.99967 10.0001 8.7012 10.0001 8.33301C10.0001 7.96482 9.7016 7.66634 9.33341 7.66634H6.66675Z"
	})]
});
export default SvgArchiveIcon;
